export const NAVIGATION_DELAY = 400;
